import { Button } from '@/components/ui/button';
import { CopyLinkField } from '@/components/CopyLinkField';
import { InviteClientHeader } from '@/components/invite-client/InviteClientHeader';

import { ChevronLeft, ChevronRight } from 'lucide-react';

import { useInviteClientContext } from '@/components/invite-client/InviteClientContext';

export function InviteClientLinkInfo() {
  const { handleStepChange, generateShareableLink } = useInviteClientContext();

  return (
    <>
      <InviteClientHeader
        title="Copy Shareable Link"
        description="Get a unique link that you can share with clients through text, social media, or in person"
      />
      <div className="mt-4">
        <CopyLinkField
          label="Intake Form Link"
          url={generateShareableLink()}
          tooltipContent={
            <div className="text-sm font-normal">
              This link can be shared with multiple clients. Each will receive a unique Intake Form
            </div>
          }
        />
        <Button
          type="button"
          variant="outline"
          className="w-full"
          onClick={() => handleStepChange('link-additional-settings')}
        >
          Additional settings
          <ChevronRight className="size-4" />
        </Button>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <Button
          variant="outline"
          onClick={() => handleStepChange('method')}
        >
          <ChevronLeft className="size-4" />
          Back
        </Button>
      </div>
    </>
  );
}
